import React from "react";
import { Grid, Stack, Typography } from "@mui/material";
import { GARANZIE_CONFIG } from "../../constants";
import GaranziaCard from "../GaranziaCard";

const GaranzieList = () => {
  return (
    <Stack spacing={2} sx={{ height: "100%" }}>
      <Typography variant="h6" fontWeight={700} mb={1}>
        Garanzie Incluse
      </Typography>

      {GARANZIE_CONFIG.map((garanzia) => (
        <GaranziaCard
          key={garanzia.key}
          title={garanzia.title}
          description={garanzia.description}
        />
      ))}
    </Stack>
  );
};

export default GaranzieList;
